import { ReactComponent as CloseIcon } from '@svgs/keyline/close.svg'
import styles from './styles.module.scss'

type FiltersHeaderProps = {
  onClose: () => void
}

export default function FiltersHeader({ onClose }: FiltersHeaderProps) {
  return (
    <div className={styles.header}>
      <h3>Filter</h3>
      <button className={styles.closeButton} onClick={onClose}>
        <CloseIcon />
      </button>
    </div>
  )
}
